import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
// index.css must come after Bootstrap so its rules win. The production build
// gives that for free (the vendor CSS chunk is linked before the app chunk),
// but the dev server injects <style> tags in import order, so the order here
// is what makes the two agree.
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

